module.exports = __webpack_public_path__ + "static/img/number.7e0faaa5.svg";